/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'company-hub.search-extension.custom-search-config-panel.corner-style-label': 'Cantos',
  'company-hub.search-extension.custom-search-config-panel.default-placeholder-text':
    'Pesquise anúncios, recursos e políticas verificados',
  'company-hub.search-extension.custom-search-config-panel.filters-title': 'Filtros',
  'company-hub.search-extension.custom-search-config-panel.placeholder-text-label': 'Texto do espaço reservado',
  'company-hub.search-extension.custom-search-config-panel.placeholder-tooltip-label':
    'Personalize o prompt que os leitores vão ver',
  'company-hub.search-extension.custom-search-config-panel.preamble': 'Adicionar uma barra de pesquisa filtrada',
  'company-hub.search-extension.custom-search-config-panel.round-corner-style-label': 'Arredondado',
  'company-hub.search-extension.custom-search-config-panel.sharp-corner-style-label': 'Quadrado',
  'company-hub.search-extension.custom-search-config-panel.styles-fill-color-label': 'Preencher cor',
  'company-hub.search-extension.custom-search-config-panel.styles-text-color-label': 'Cor do texto',
  'company-hub.search-extension.custom-search-config-panel.styles-title': 'Estilos',
  'company-hub.search-extension.custom-search-config-panel.title': 'Pesquisa personalizada',
  'company-hub.search-extension.manifest.default-placeholder-text':
    'Pesquise anúncios, recursos e políticas verificados',
  'company-hub.search-extension.manifest.macro-description': 'Adicionar uma barra de pesquisa filtrada',
  'company-hub.search-extension.manifest.macro-title': 'Pesquisa personalizada',
  'company-hub.search-extension.more-button': 'Visualizar mais resultados',
};
